import EmberRouter from '@ember/routing/router';
import config from './config/environment';

export default class Router extends EmberRouter 
{
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function()
{
	this.route('sources');
	this.route('destinations');
	this.route('destination-files', { path: '/destinations/:destination_id/files' });
	this.route('datasets');
	this.route('monitor');
});
